import _ from 'lodash';
import assetTypeApi from '@/api/assetTypeApi';
import { fetchOnce } from '@/store/utils/fetchOnce';

export default {
	namespace: true,

	state: {
		assetTypeCodes: {},
		currAssetTypeCode: {},
		assetTypeCodesLoaded: false
	},

	mutations: {
		SET_ALL_ASSET_TYPE_CODES(state, assetTypeCodes) {
			state.assetTypeCodes = assetTypeCodes;
		},
		SET_CURR_ASSET_TYPE_CODE(state, assetTypeCode) {
			state.currAssetTypeCode = assetTypeCode;
		},
		SET_ASSET_TYPE_CODES_LOADED(state, val) {
			state.assetTypeCodesLoaded = val;
		}
	},

	actions: {
		setAllAssetTypeCodes(vuexContext, assetTypeCodes) {
			vuexContext.commit('SET_ALL_ASSET_TYPE_CODES', assetTypeCodes);
		},
		fetchAssetTypeCodesIfNeeded({ state, commit }, { filterBy, view, currUserId }) {
			if (state.assetTypeCodesLoaded) return Promise.resolve();
			return fetchOnce('assetTypeCodes', () =>
				assetTypeApi.getAssetTypeCodes(filterBy, view, currUserId).then(({ data }) => {
					if (data.isSuccess) {
						commit('SET_ALL_ASSET_TYPE_CODES', data.assetTypeCodes);
						commit('SET_ASSET_TYPE_CODES_LOADED', true);
					}
					return data;
				})
			);
		},
		updateAllAssetTypeCodes(vuexContext, newAssetTypeCodes) {
			let assetTypeCodes = vuexContext.getters.assetTypeCodes;

			_.forEach(newAssetTypeCodes, (value, key) => {
				assetTypeCodes[key] = value;
			});

			vuexContext.commit('SET_ALL_ASSET_TYPE_CODES', assetTypeCodes);
		}
	},

	getters: {
		assetTypeCodes(state) {
			if (!_.isEmpty(state.assetTypeCodes)) {
				return state.assetTypeCodes;
			}
			return {};
		},
		currAssetTypeCode(state) {
			if (!_.isEmpty(state.currAssetTypeCode)) {
				return state.currAssetTypeCode;
			}
			return {};
		},
	}
}
